/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SentryErrorBoundaryFallback/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DevelopmentOnly from 'DesignSystem/DevelopmentOnly/index'
import ErrorBoundary from 'DesignSystem/ErrorBoundary/index'
import EventId from './EventId/index'
import React from 'react'
import SignOutAction from './SignOutAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SentryErrorBoundaryFallback({
  children,
  viewPath = "/DesignSystem/SentryErrorBoundary/SentryErrorBoundaryFallback"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let errorMessageValueData = fromData.useDataValue({ viewPath,
context: 'error',
path: 'message',
})
let errorStackValueData = fromData.useDataValue({ viewPath,
context: 'error',
path: 'stack',
})
let errorResetErrorValueData = fromData.useDataValue({ viewPath,
context: 'error',
path: 'resetError',
})
  return (<React.Fragment
>
<div
  data-testid="SentryErrorBoundaryFallback.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SentryErrorBoundaryFallback.Vertical:1"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-Z2sKAla': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-5-Z2sKAla': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-6-Z2sKAla': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-7-Z2sKAla': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-8-Z2sKAla': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<EventId
  viewPath={`${viewPath}/EventId`}
/>
<DevelopmentOnly
  viewPath={`${viewPath}/DevelopmentOnly`}
>
{childProps => (
<ErrorBoundary
{...childProps}
  viewPath={`${viewPath}/ErrorBoundary`}
 data="error.message"
 message={errorMessageValueData}
 data="error.stack"
 stack={errorStackValueData}
 data="error.resetError"
 onClick={errorResetErrorValueData}
/>
)}
</DevelopmentOnly>
<SignOutAction
  viewPath={`${viewPath}/SignOutAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}